import ProductGroupsApi from './ProductGroupsApi';
import * as ActionTypes from './ActionTypes';
import IProductGroup from './IProductGroup';
import IProductGroupListItem from './list/IProductGroupListItem';

function loadProductGroupsSuccess(results: IProductGroupListItem[]) {
    return { type: ActionTypes.LOAD_PRODUCT_GROUPS_SUCCESS, result: results };
}

function createProductGroupSuccess(result: IProductGroupListItem) {
    return { type: ActionTypes.CREATE_PRODUCT_GROUP_SUCCESS, result };
}

function newProductGroupSuccess(result: IProductGroup) {
    return { type: ActionTypes.NEW_PRODUCT_GROUP_SUCCESS, result };
}

function loadEditProductGroupSuccess(result: IProductGroup) {
    return { type: ActionTypes.LOAD_EDIT_PRODUCT_GROUP_SUCCESS, result };
}

function updateProductGroupSuccess(result: IProductGroupListItem) {
    return { type: ActionTypes.UPDATE_PRODUCT_GROUP_SUCCESS, result };
}

function deleteProductGroupSuccess(id: number) {
    return {
        type: ActionTypes.DELETE_PRODUCT_GROUP_SUCCESS,
        result: { id: id }
    };
}

export function loadProductGroups() {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        ProductGroupsApi.getProductGroups().then((result: IProductGroupListItem[]) =>
            dispatch(loadProductGroupsSuccess(result))
        );
}

export function createProductGroup(productGroup: any) {
    return (dispatch: any, getState: any) =>
        ProductGroupsApi.createProductGroup(productGroup).then((result: IProductGroupListItem) =>
            dispatch(createProductGroupSuccess(result))
        );
}

export function newProductGroup() {
    return (dispatch: any, getState: any) =>
        ProductGroupsApi.newProductGroup().then((result: IProductGroup) =>
            dispatch(newProductGroupSuccess(result))
        );
}

export function loadEditProductGroup(id: number) {
    return (dispatch: (result: any) => void) =>
        ProductGroupsApi.loadEditProductGroup(id).then((result: any) =>
            dispatch(loadEditProductGroupSuccess(result))
        );
}

export function updateProductGroup(productGroup: any) {
    return (dispatch: any, getState: any) =>
        ProductGroupsApi.updateProductGroup(productGroup).then((result: IProductGroupListItem) =>
            dispatch(updateProductGroupSuccess(result))
        );
}

export function deleteProductGroup(id: number) {
    return (dispatch: any, getState: any) =>
        ProductGroupsApi.deleteProductGroup(id).then(() => dispatch(deleteProductGroupSuccess(id)));
}
